const animationLeaveCircleLoader = (trigger) => {
  const loader = document.querySelector('.loader');

  // reset loader to be invisible on page load
  gsap.set('.loader', { scale: 0 });

  // console.log(trigger.getBoundingClientRect());
  const { height, width, top, left } = trigger.getBoundingClientRect();
  const triggerTop = Math.floor(top);
  const triggerLeft = Math.floor(left);
  const triggerWidth = Math.floor(width);
  const triggerHeight = Math.floor(height);
  // console.log({triggerTop, triggerLeft, triggerHeight, triggerWidth});

  // GSAP timeline to stretch the loading screen across the whole screen

  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;
  const loaderSize =
    viewportHeight > viewportWidth ? viewportHeight * 2.5 : viewportWidth * 2.5;

  let tl = gsap.timeline();

  tl.set(loader, {
    autoAlpha: 1,
    x: triggerLeft + triggerWidth / 2,
    y: triggerTop + triggerHeight / 2,
    width: loaderSize,
    height: loaderSize,
    xPercent: -50,
    yPercent: -50,
  }).fromTo(
    loader,
    {
      scale: 0,
      transformOrigin: 'center center',
    },
    {
      duration: 0.8,
      scale: 1,
      ease: 'Power4.out',
    }
  );
  return tl;
};

export default animationLeaveCircleLoader;
